export class CustomerModel{
    customerId:any;
    customerNumber:string;
    title:string;
    firstName:string;
    lastName:string;
    displayName:string;
    customerTypeId:any;
    industryId:any;
    parentCustomerId:any;
    noOfBranches:any;
    noOfEmployees:any;
    currencyId:any;
    languageId:any;
    sourceId:any;
    referral:string;
    phone:string;
    mobile:string;
    email:string;
    website:string;
    fax:string;
    skype:string;
    ssnNumber:string;
    vatNumber:string;
    bdiNumber:string;
    obNumber:string;
    countryId:any;
    regionId:any;
    provinceId:any;
    cityId:any;
    suburbId:any;
    thumbnailImage:string;
    largeImage:string;
    signatureImage:string;
    description:string;
    customerStatusId:any;
    isDeleted:boolean;
    isActive:boolean;

}